import settings from '../settings';
import $ from 'jquery';
import _ from 'lodash';
import horsey from 'horsey';

export default class JumpTo {

  constructor() {
    this.init();
    this.channels = [];
  }

  init() {
    this.renderSearch();
  }

  renderSearch() {
    $('#jump-to').on('modal-open', function (e) {
      var input = $(this).find("input");
      input.removeAttr('disabled');
      input.focus();

      var request = $.ajax({
        headers: settings.api_headers,
        url: '/channels',
        type: 'GET',
        dataType: 'json'
      });

      request.always(function (data, status, jqXHR) {
        this.channels = data.channels;

        if ($('#channel-search').length) {
          let that = this;

          $('#channel-search').keyup(function (event) {
            if (event.which === 13) {
              setTimeout(() => {
                const channelName = $(this).val();

                let channel = that.channels.filter(channel => {
                  return channelName == channel.name;
                });

                if (channel.length < 1) return false;
                if (channel.length >= 1) channel = channel[0];

                window.modals['jump-to'].close();

                window.location = '/posts?channel_id=' + channel.id;
              }, 100);

              return false;
            }
          });

          const data = this.channels.map(channel => {
            return {value: channel.id, text: channel.name, channel: channel};
          });

          horsey(document.querySelector('#channel-search'), {
            source: [{ list: data }],
            getText: 'text',
            getValue: 'value',
            appendTo: document.querySelector('#jump-to .modal__content form'),
            renderItem: function (li, suggestion) {
              let channel = suggestion.channel;
              let icon = '<i style="opacity: 0;" class="fa fa-check"></i>';
              let subtitle = '';

              if (!channel.user_following){
                  li.classList.add('hidden');
                  return;
              }

              if (channel.status == 'active' && channel.user_following) {
                icon = '<i class="fa fa-check"></i>';
              }

              if (channel.user_following) {
                subtitle = '<span class="sey-subtitle">(Subscribed)</span>';
              }

              li.innerHTML = '<a href="/posts?channel_id=' + channel.id + '">' + icon + channel.name + subtitle + '</a>';
            }
          });
          // horsey.refreshPosition();
        }
      });
    })
  }

}
